import React from "react";

function Topstatusbar() {
	return (
		<div className="top-status-bar">
            <div className="inner-top-status-bar">
                <h3 className="statucbartext">
                * A Certified Tour Operator by Ministry of Tourism, Govt. of India *
                </h3>
            </div>
        </div>
	);
}

export default Topstatusbar;
